/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Modal, Tabs } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { useIntl } from 'react-intl';
import { useStyles } from '~src/hooks/useStyles';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useProjectId } from '~src/hooks/useProjectId';
import { useTenderId } from '~src/hooks/useTenderId';
import { TenderRegistrationVM } from '~src/types/db';
import { TenderPublicTab } from '~components/popups-modals/TenderOptionsModal/Tabs/TenderPublicTab';
import TenderInvitationTab from '~components/popups-modals/TenderOptionsModal/Tabs/TenderInvitationTab';

interface TenderOptionsModalProps extends Partial<ModalProps> {
  tenderId?: number;
  tenderRegistration?: TenderRegistrationVM;
  onDone?: () => void;
  onCancel?: () => void;
}

export const TenderOptionsModal: React.FC<TenderOptionsModalProps> = ({
  tenderId: tenderIdProp,
  tenderRegistration,
  onDone,
  onCancel,
  ...modalProps
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);
  const projectId = useProjectId();
  const fallbackTenderId = useTenderId();

  const tenderId = tenderIdProp ?? fallbackTenderId;

  const isModalVisible =
    (modalProps as any).visible ?? (modalProps as any).open ?? false;

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'tender-options' })}
          icon={['far', 'cog']}
        />
      }
      width={600}
      centered
      destroyOnClose
      onCancel={onCancel}
      footer={null}
      {...modalProps}
      bodyStyle={{ padding: 0 }}>
      <Tabs
        defaultActiveKey="public-tender"
        tabBarStyle={{ padding: '0 30px', marginBottom: 0 }}>
        <Tabs.TabPane
          key="public-tender"
          tab={intl.formatMessage({ id: 'public-tender' })}>
          <div css={styles.tabContent}>
            <TenderPublicTab
              projectId={projectId}
              tenderId={tenderId}
              tenderRegistration={tenderRegistration}
            />
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane
          key="invitation"
          tab={intl.formatMessage({
            id: 'invite-invitation',
            defaultMessage: 'Invitation',
          })}>
          <div css={styles.tabContent}>
            <TenderInvitationTab
              projectId={projectId}
              tenderId={tenderId}
              tenderRegistration={tenderRegistration}
              isVisible={isModalVisible}
            />
          </div>
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};

const styleFn = () => ({
  tabContent: {
    padding: '24px',
  },
});

export default TenderOptionsModal;
